import { useState, useEffect, useMemo } from "react";
import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../css/custom-datatable.css";
import "../css/PopupMessage.css";

import CheckBox from "../../components/CheckBox";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import InputSearch from "../../components/InputSearch";
import Dropdown from "../../components/Dropdown";
import DropdownFilter from "../../components/DropdownFilter";
import ButtonIconV from "../../components/ButtonIconV";
import CashPopup from "../components/CashPopup";
import CashMovementPopup from "../components/CashMovementPopup";
import PopupInvoicePrinting, {
  printInvoice,
  printInvoiceDirect,
  openDataUriInNewTab,
} from "../components/PopupInvoicePrinting";
import PopupInvoicePrintingSimple from "../components/PopupInvoicePrintingSimple";
import PopupEmail from "../components/PopupEmail";
import TooltipBox from "../../components/Tooltip";

import { PRODUCT_FAMILIES } from "../js/constants";
import { post as rpost } from "../js/api";
import { exportToFile } from "../js/exportToFile";
import { formatCurrency, formatFloatFromCurrency } from "../utils/utils";

import { LIMIT } from "../../js/utils";
import { userData, selectedOptic, inputOnEnter } from "../../js/utils";

import DataTable from "react-data-table-component";
import moment from "moment";

const ESTADO_PRESUPUESTO_OPTIONS = [
  { id: 1, text: "ACEPTADO" },
  { id: 0, text: "RECHAZADO" },
];

/*const ventasOr = [
  {
    id: "25-000004",
    status: "RECTIFICATIVA",
    date: "2025-01-15 18:00:00",
    patient: 1517,
    name: "JOSÉ MARÍA",
    lastName: "HERNÁNDEZ JIMÉNEZ",
    phone: "657409846",
    total: 2495,
    paid: 2000,
    remaining: 495,
    deliver: true,
  },
  {
    id: "25-000003",
    status: "ANULADA",
    date: "2025-01-11 12:00:00",
    patient: 35,
    name: "MARÍA ANTONIA",
    lastName: "GARCÍA RIVERA",
    phone: "927626257",
    total: 135,
    paid: 135,
    remaining: 0,
    deliver: false,
  },
  {
    id: "25-000002",
    status: "VENTA",
    date: "2025-01-03 19:48:00",
    patient: 501,
    name: "MARÍA DEL CARMEN",
    lastName: "DE LA MONTAÑA MARTÍN",
    phone: "",
    total: 135,
    paid: 0,
    remaining: 135,
    deliver: false,
  },
  {
    id: "25-000001",
    status: "RECTIFICADA",
    date: "2025-01-02 09:48:00",
    patient: 942,
    name: "DAVID",
    lastName: "GONZÁLEZ DEL CAMPO",
    phone: "722659821",
    total: 690,
    paid: 690,
    remaining: 0,
    deliver: false,
  },
];*/

/*const encargosOr = [
  {
    id: "25-000002",
    date: "2025-01-03 19:48:00",
    patient: 501,
    name: "MARÍA DEL CARMEN",
    lastName: "DE LA MONTAÑA MARTÍN",
    phone: "",
    total: 135,
  },
  {
    id: "25-000001",
    date: "2025-01-02 09:48:00",
    patient: 942,
    name: "DAVID",
    lastName: "GONZÁLEZ DEL CAMPO",
    phone: "722659821",
    total: 690,
  },
];

const presupuestosProformasOr = [
  {
    id: "25-000002",
    date: "2025-01-03 19:48:00",
    patient: 501,
    name: "MARÍA DEL CARMEN",
    lastName: "DE LA MONTAÑA MARTÍN",
    phone: "",
    total: 135,
    validDate: "2025-01-31",
    presupuesto: true,
  },
  {
    id: "25-000001",
    date: "2025-01-02 09:48:00",
    patient: 942,
    name: "DAVID",
    lastName: "GONZÁLEZ DEL CAMPO",
    phone: "722659821",
    total: 690,
    validDate: "2025-01-31",
    presupuesto: false,
  },
];*/

export default ({
  show,
  onClickMenuOption,
  createPopupQuestion,
  removePopupQuestion,
  onGoBack,
  debtor = null,
  orderer = null,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [ventas, setVentas] = useState([]);
  const [ventasTable, setVentasTable] = useState([]);
  const [encargos, setEncargos] = useState([]);
  const [encargosTable, setEncargosTable] = useState([]);
  const [presupuestosProformas, setPresupuestosProformas] = useState([]);
  const [presupuestosProformasTable, setPresupuestosProformasTable] = useState(
    [],
  );
  const [showVentas, setShowVentas] = useState(true);
  const [showEncargos, setShowEncargos] = useState(true);
  const [showPresupuestosProformas, setShowPresupuestosProformas] =
    useState(true);
  const [filterIdPaciente, setFilterIdPaciente] = useState(-1);
  const [filterCodPaciente, setFilterCodPaciente] = useState("");
  const [filterCodProducto, setFilterCodProducto] = useState("");
  const [filterNombre, setFilterNombre] = useState("");
  const [filterApellidos, setFilterApellidos] = useState("");
  const [filterTelefono, setFilterTelefono] = useState("");
  const [filterNOperacion, setFilterNOperacion] = useState("");
  const [filterFechaDesde, setFilterFechaDesde] = useState("");
  const [filterFechaHasta, setFilterFechaHasta] = useState("");
  const [filterImporteDesde, setFilterImporteDesde] = useState("");
  const [filterImporteHasta, setFilterImporteHasta] = useState("");
  const [filterFamiliaProducto, setFilterFamiliaProducto] = useState(
    PRODUCT_FAMILIES[0],
  );
  const [agents, setAgents] = useState([
    {
      id: -1,
      text: "",
    },
  ]);
  const [filterRealizadoPor, setFilterRealizadoPor] = useState({
    id: -1,
    text: "",
  });
  const [filterEntregadoPor, setFilterEntregadoPor] = useState({
    id: -1,
    text: "",
  });
  const [showControlSanitario, setShowControlSanitario] = useState(false);
  const [filterAlbaran, setFilterAlbaran] = useState("");
  const [filterExpedicion, setFilterExpedicion] = useState("");
  const [filterLote, setFilterLote] = useState("");
  const [filterVentasPendientesAbono, setFilterVentasPendientesAbono] =
    useState(false);
  const [filterVentasPendientesEntrega, setFilterVentasPendientesEntrega] =
    useState(false);
  const [filterVentasEstado, setFilterVentasEstado] = useState([]);
  const [ventasCounter, setVentasCounter] = useState(0);
  const [ventasLimit, setVentasLimit] = useState(LIMIT);
  const [encargosCounter, setEncargosCounter] = useState(0);
  const [encargosLimit, setEncargosLimit] = useState(LIMIT);
  const [presupuestosCounter, setPresupuestosCounter] = useState(0);
  const [presupuestosLimit, setPresupuestosLimit] = useState(LIMIT);
  const [filterPresupuestos, setFilterPresupuestos] = useState(true);
  const [filterProformas, setFilterProformas] = useState(true);
  const [filterEstadoPresupuesto, setFilterEstadoPresupuesto] = useState([]);
  const [presupuestosProformasLimit, setPresupuestosProformasLimit] =
    useState(LIMIT);
  const [numLoadedVentas, setNumLoadedVentas] = useState(0);
  const [numLoadedEncargos, setNumLoadedEncargos] = useState(0);
  const [numLoadedPresupuestosProformas, setNumLoadedPresupuestosProformas] =
    useState(0);

  const [showCashPopup, setShowCashPopup] = useState(false);
  const [cashMovementPopup, setCashMovementPopup] = useState(null);
  const [showVentasInvoicePrintingPopup, setShowVentasInvoicePrintingPopup] =
    useState(false);
  const [
    showEncargosInvoicePrintingPopup,
    setShowEncargosInvoicePrintingPopup,
  ] = useState(false);
  const [
    showPresupuestosProformasInvoicePrintingPopup,
    setShowPresupuestosProformasInvoicePrintingPopup,
  ] = useState(false);
  const [showVentasEmailPrintingPopup, setShowVentasEmailPrintingPopup] =
    useState(false);
  const [showVentasEmailPopup, setShowVentasEmailPopup] = useState(false);
  const [ventasEmailAttachment, setVentasEmailAttachment] = useState(null);

  const ventasColumns = useMemo(
    () => [
      {
        name: "Venta",
        selector: (row) => (row.id === "" ? "-" : row.nOperation),
        sortable: true,
        width: "7%",
      },
      {
        name: "Estado",
        selector: (row) => (row.id === "" ? "" : row.status.toUpperCase()),
        sortable: true,
        width: "9%",
      },
      {
        name: "Fecha",
        selector: (row) =>
          row.id === ""
            ? moment(row.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
            : moment(row.date, "YYYY-MM-DD HH:mm:ss").format(
                "DD/MM/YYYY HH:mm",
              ),
        sortable: true,
        sortFunction: (a, b) => {
          const dateA = moment(a.date, "YYYY-MM-DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm",
          );
          const dateB = moment(b.date, "YYYY-MM-DD HH:mm").format(
            "DD/MM/YYYY HH:mm",
          );

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return 0;
        },
        width: "10%",
      },
      {
        name: "Paciente",
        selector: (row) => row.patient,
        sortable: true,
        width: "7%",
      },
      {
        name: "Nombre",
        selector: (row) => row.name,
        sortable: true,
        width: "11%",
      },
      {
        name: "Apellidos",
        selector: (row) => row.lastName,
        sortable: true,
        width: "13%",
      },
      {
        name: "Teléfono",
        selector: (row) => row.phone,
        sortable: true,
        width: "8%",
      },
      {
        name: "Total",
        selector: (row) => (row.id === "" ? "-" : row.total),
        sortable: true,
        sortFunction: (a, b) => {
          const numA = formatFloatFromCurrency(a.total);
          const numB = formatFloatFromCurrency(b.total);
          return numA - numB;
        },
        width: "8%",
        right: true,
      },
      {
        name: "Abono",
        selector: (row) => (row.id === "" ? "-" : row.paid),
        sortable: true,
        sortFunction: (a, b) => {
          const numA = formatFloatFromCurrency(a.paid);
          const numB = formatFloatFromCurrency(b.paid);
          return numA - numB;
        },
        width: "8%",
        right: true,
      },
      {
        name: "Pendiente",
        selector: (row) => row.remaining,
        sortable: true,
        sortFunction: (a, b) => {
          const numA =
            a.remaining === "-" ? 0 : formatFloatFromCurrency(a.remaining);
          const numB =
            b.remaining === "-" ? 0 : formatFloatFromCurrency(b.remaining);
          return numA - numB;
        },
        width: "9%",
        right: true,
      },
      {
        name: "Entrega",
        selector: (row) => row.deliver,
        sortable: true,
        width: "6%",
        center: true,
        cell: (row) =>
          row.deliver ? (
            <img className="cellIcon" src="/images/check-blue.svg" />
          ) : null,
      },
      {
        name: "",
        sortable: false,
        width: "4%",
        cell: (row) =>
          row.id === "" ? null : (
            <div
              className="data-field c-pointer"
              style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                const ventasTableN = structuredClone(ventasTable);
                const r = ventasTableN.find((item) => {
                  return item.id === row.id;
                });
                if (r) {
                  r.selected = !r.selected;
                }
                setVentasTable(ventasTableN);
              }}
            >
              <CheckBox active={row.selected} onClick={() => {}} />
            </div>
          ),
      },
    ],
    [ventasTable],
  );

  const encargosColumns = useMemo(
    () => [
      {
        name: "Encargo",
        selector: (row) => row.nOperation,
        sortable: true,
        width: "10%",
      },
      {
        name: "Fecha",
        selector: (row) => row.date,
        sortable: true,
        sortFunction: (a, b) => {
          const dateA = moment(a.date, "DD/MM/YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm",
          );
          const dateB = moment(b.date, "DD/MM/YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm",
          );

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return 0;
        },
        width: "16%",
      },
      {
        name: "Paciente",
        selector: (row) => row.patient,
        sortable: true,
        width: "9%",
      },
      {
        name: "Nombre",
        selector: (row) => row.name,
        sortable: true,
        width: "15%",
      },
      {
        name: "Apellidos",
        selector: (row) => row.lastName,
        sortable: true,
        width: "20%",
      },
      {
        name: "Teléfono",
        selector: (row) => row.phone,
        sortable: true,
        width: "9%",
      },
      {
        name: "Total",
        selector: (row) => row.total,
        sortable: true,
        sortFunction: (a, b) => {
          const numA = formatFloatFromCurrency(a.total);
          const numB = formatFloatFromCurrency(b.total);
          return numA - numB;
        },
        width: "11%",
        right: true,
      },
      {
        name: "",
        sortable: false,
        width: "5%",
        center: true,
        cell: (row) => {
          const daysSince = moment().diff(
            moment(row.date, "DD/MM/YYYY HH:mm"),
            "days",
          );
          if (daysSince <= 15) {
            return "";
          }

          const tooltipId = `encargo-aviso-${row.id}`;
          return (
            <div
              className="data-field"
              style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <img
                src="/images/support-extra/aviso.svg"
                className="icon-pref"
                alt="Aviso"
                data-tooltip-id={tooltipId}
              ></img>
              <TooltipBox
                id={tooltipId}
                content="Encargo con más de 15 días."
              />
            </div>
          );
        },
      },
      {
        name: "",
        sortable: false,
        width: "5%",
        cell: (row) => (
          <div
            className="data-field c-pointer"
            style={{ width: "100%", height: "100%", justifyContent: "center" }}
            onClick={(e) => {
              e.stopPropagation();
              const encargosTableN = structuredClone(encargosTable);
              const r = encargosTableN.find((item) => {
                return item.id === row.id;
              });
              if (r) {
                r.selected = !r.selected;
              }
              setEncargosTable(encargosTableN);
            }}
          >
            <CheckBox active={row.selected} onClick={() => {}} />
          </div>
        ),
      },
    ],
    [encargosTable],
  );

  const presupuestosProformasColumns = useMemo(
    () => [
      {
        name: "Id",
        selector: (row) => row.nOperation,
        sortable: true,
        width: "9%",
      },
      {
        name: "Fecha",
        selector: (row) => row.date,
        sortable: true,
        sortFunction: (a, b) => {
          const dateA = moment(a.date, "DD/MM/YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm",
          );
          const dateB = moment(b.date, "DD/MM/YYYY HH:mm").format(
            "YYYY-MM-DD HH:mm",
          );

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return 0;
        },
        width: "13%",
      },
      {
        name: "Paciente",
        selector: (row) => row.patient,
        sortable: true,
        width: "8%",
      },
      {
        name: "Nombre",
        selector: (row) => row.name,
        sortable: true,
        width: "14%",
      },
      {
        name: "Apellidos",
        selector: (row) => row.lastName,
        sortable: true,
        width: "17%",
      },
      {
        name: "Teléfono",
        selector: (row) => row.phone,
        sortable: true,
        width: "9%",
      },
      {
        name: "Total",
        selector: (row) => row.total,
        sortable: true,
        sortFunction: (a, b) => {
          const numA = formatFloatFromCurrency(a.total);
          const numB = formatFloatFromCurrency(b.total);
          return numA - numB;
        },
        width: "10%",
        right: true,
      },
      {
        name: "Válido hasta",
        selector: (row) =>
          moment(row.expirationDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        sortable: true,
        sortFunction: (a, b) => {
          const dateA = moment(a.expirationDate, "DD/MM/YYYY").format(
            "YYYY-MM-DD",
          );
          const dateB = moment(b.expirationDate, "DD/MM/YYYY").format(
            "YYYY-MM-DD",
          );

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return 0;
        },
        width: "10%",
        wrap: false,
      },
      {
        name: "Estado",
        selector: (row) => {
          if (row.status !== true && row.status !== false) {
            return "";
          }

          const icon = row.status
            ? "/images/check-blue.svg"
            : "/images/support-extra/cancelar.svg";
          const label = row.status ? "Aceptado" : "Rechazado";
          const tooltipId = `presupuesto-proforma-estado-${row.id}`;

          return (
            <>
              <img
                src={icon}
                className="icon-pref"
                alt={label}
                data-tooltip-id={tooltipId}
              ></img>
              <TooltipBox id={tooltipId} content={label} />
            </>
          );
        },
        sortable: false,
        center: true,
        width: "5%",
      },
      {
        name: "",
        sortable: false,
        width: "5%",
        cell: (row) => (
          <div
            className="data-field c-pointer"
            style={{ width: "100%", height: "100%", justifyContent: "center" }}
            onClick={(e) => {
              e.stopPropagation();
              const presupuestosProformasTableN = structuredClone(
                presupuestosProformasTable,
              );
              const r = presupuestosProformasTableN.find((item) => {
                return item.id === row.id;
              });
              if (r) {
                r.selected = !r.selected;
              }
              setPresupuestosProformasTable(presupuestosProformasTableN);
            }}
          >
            <CheckBox active={row.selected} onClick={() => {}} />
          </div>
        ),
      },
    ],
    [presupuestosProformasTable],
  );

  const loadAgents = async () => {
    const response = await rpost("fichas/ListarAgentes.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    const agents = response.map((item) => {
      return {
        id: item.id,
        text: item.nombreApellidos,
      };
    });
    agents.unshift({
      id: -1,
      text: "",
    });
    setAgents(agents);
    setFilterRealizadoPor(agents[0]);
  };

  const loadVentas = async (append, start) => {
    const response = await rpost("ventas/BuscarVentas.php", {
      token: userData.token,
      optica: selectedOptic.id,
      codigoPaciente: filterCodPaciente,
      codigoProducto: filterCodProducto,
      nombre: filterNombre,
      apellidos: filterApellidos,
      telefono: filterTelefono,
      nOperacion: filterNOperacion,
      fechaDesde: filterFechaDesde,
      fechaHasta: filterFechaHasta,
      importeDesde: filterImporteDesde,
      importeHasta: filterImporteHasta,
      familia:
        filterFamiliaProducto.id === "-1" ? "" : filterFamiliaProducto.id,
      realizadoPor: filterRealizadoPor.text,
      entregadoPor: filterEntregadoPor.text,
      albaran: filterAlbaran,
      expedicion: filterExpedicion,
      lote: filterLote,
      pendientesAbono:
        filterVentasPendientesAbono === true ? filterVentasPendientesAbono : "",
      pendientesEntrega:
        filterVentasPendientesEntrega === true
          ? filterVentasPendientesEntrega
          : "",
      estados: filterVentasEstado,
      start,
      total: append ? ventasLimit : ventasLimit + ventasCounter,
    });

    let ventasN = response.ventas.map((venta) => {
      // Si la venta está marcada como pagada no queda nada pendiente,
      // sea cual sea la diferencia entre total y abono.
      const remaining =
        venta.pagado == 1 || venta.abono < 0 ? 0 : venta.total - venta.abono;

      return {
        id: venta.idVenta,
        nOperation: venta.nOperacion,
        status: venta.estado,
        date: venta.fechaHora,
        patient: venta.codigoPaciente,
        name: venta.nombre,
        lastName: venta.apellidos,
        phone: venta.telefono,
        total: venta.total,
        paid: venta.abono,
        remaining,
        deliver: venta.entregado == 1,
      };
    });

    let ventasTableN = ventasN.map((venta) => {
      return {
        id: venta.id,
        nOperation: venta.nOperation,
        status: venta.status,
        date: venta.date,
        patient: venta.patient,
        name: venta.name,
        lastName: venta.lastName,
        phone: venta.phone,
        total: formatCurrency(venta.total),
        paid: formatCurrency(venta.paid),
        remaining:
          venta.remaining === 0 ? "-" : formatCurrency(venta.remaining),
        deliver: venta.deliver,
        selected: false,
      };
    });

    if (append) {
      ventasN = ventas.concat(ventasN);
      ventasTableN = ventasTable.concat(ventasTableN);
    }

    setVentas(ventasN);
    setVentasTable(ventasTableN);
    setNumLoadedVentas(response.totalBusqueda);
  };

  const loadEncargos = async (append, start) => {
    if (filterAlbaran !== "" || filterExpedicion !== "" || filterLote !== "") {
      setEncargos([]);
      setEncargosTable([]);
      setNumLoadedEncargos(0);
      return;
    }

    const response = await rpost("ventas/BuscarEncargo.php", {
      token: userData.token,
      optica: selectedOptic.id,
      codigoPaciente: filterCodPaciente,
      codigoProducto: filterCodProducto,
      nombre: filterNombre,
      apellidos: filterApellidos,
      telefono: filterTelefono,
      nEncargo: filterNOperacion,
      fechaDesde: filterFechaDesde,
      fechaHasta: filterFechaHasta,
      importeDesde: filterImporteDesde,
      importeHasta: filterImporteHasta,
      familia:
        filterFamiliaProducto.id === "-1" ? "" : filterFamiliaProducto.id,
      realizadoPor: filterRealizadoPor.text,
      start,
      total: append ? encargosLimit : encargosLimit + encargosCounter,
    });

    let encargosN = response.encargos.map((encargo) => {
      return {
        id: encargo.idEncargo,
        nOperation: encargo.nEncargo,
        date: encargo.fechaHora,
        patient: encargo.codigoPaciente,
        name: encargo.nombre,
        lastName: encargo.apellidos,
        phone: encargo.telefono,
        total: encargo.total,
      };
    });

    let encargosTableN = encargosN.map((encargo) => {
      return {
        id: encargo.id,
        nOperation: encargo.nOperation,
        date: moment(encargo.date, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm",
        ),
        patient: encargo.patient,
        name: encargo.name,
        lastName: encargo.lastName,
        phone: encargo.phone,
        total: formatCurrency(encargo.total),
        selected: false,
      };
    });

    if (append) {
      encargosN = encargos.concat(encargosN);
      encargosTableN = encargosTable.concat(encargosTableN);
    }

    setEncargos(encargosN);
    setEncargosTable(encargosTableN);
    setNumLoadedEncargos(response.totalBusqueda);
  };

  const loadPresupuestosProformas = async (append, start) => {
    let tipo = 2;
    if (filterPresupuestos !== filterProformas) {
      tipo = filterPresupuestos ? 0 : 1;
    }

    if (filterAlbaran !== "" || filterExpedicion !== "" || filterLote !== "") {
      setPresupuestosProformas([]);
      setPresupuestosProformasTable([]);
      setNumLoadedPresupuestosProformas(0);
      return;
    }

    const response = await rpost("ventas/BuscarPresupuestoProforma.php", {
      token: userData.token,
      optica: selectedOptic.id,
      codigoPaciente: filterCodPaciente,
      codigoProducto: filterCodProducto,
      nombre: filterNombre,
      apellidos: filterApellidos,
      telefono: filterTelefono,
      nPresupuesto: filterNOperacion,
      fechaDesde: filterFechaDesde,
      fechaHasta: filterFechaHasta,
      importeDesde: filterImporteDesde,
      importeHasta: filterImporteHasta,
      familia:
        filterFamiliaProducto.id === "-1" ? "" : filterFamiliaProducto.id,
      realizadoPor: filterRealizadoPor.text,
      estado: filterEstadoPresupuesto,
      start,
      total: append
        ? presupuestosLimit
        : presupuestosLimit + presupuestosCounter,
      tipo,
    });

    let presupuestosN = response.preprofs.map((presupuesto) => {
      return {
        id: presupuesto.idPreprof,
        nOperation: presupuesto.nPreprof,
        date: presupuesto.fechaHora,
        patient: presupuesto.codigoPaciente,
        name: presupuesto.nombre,
        lastName: presupuesto.apellidos,
        phone: presupuesto.telefono,
        total: presupuesto.total,
        expirationDate: presupuesto.fechaValidez,
        status: presupuesto.estado,
        type: presupuesto.tipo,
      };
    });

    let presupuestosProformasTableN = presupuestosN.map((presupuesto) => {
      return {
        id: presupuesto.id,
        nOperation: presupuesto.nOperation,
        date: moment(presupuesto.date, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm",
        ),
        patient: presupuesto.patient,
        name: presupuesto.name,
        lastName: presupuesto.lastName,
        phone: presupuesto.phone,
        total: formatCurrency(presupuesto.total),
        type: presupuesto.type,
        expirationDate: presupuesto.expirationDate,
        status: presupuesto.status,
        selected: false,
      };
    });

    if (append) {
      presupuestosN = presupuestosProformas.concat(presupuestosN);
      presupuestosProformasTableN = presupuestosProformasTable.concat(
        presupuestosProformasTableN,
      );
    }

    setPresupuestosProformas(presupuestosN);
    setPresupuestosProformasTable(presupuestosProformasTableN);
    setNumLoadedPresupuestosProformas(response.totalBusqueda);
  };

  /*const loadPresupuestosProformas = () => {
    const presupuestosProformasN = structuredClone(presupuestosProformasOr);

    const presupuestosProformasTableN = presupuestosProformasN.map((pres) => {
      return {
        id: pres.id,
        date: moment(pres.date, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        ),
        patient: pres.patient,
        name: pres.name,
        lastName: pres.lastName,
        phone: pres.phone,
        total: formatCurrency(pres.total),
        validDate: moment(pres.date, "YYYY-MM-DD").format("DD/MM/YYYY"),
        selected: false,
      };
    });

    setPresupuestosProformas(presupuestosProformasN);
    setPresupuestosProformasTable(presupuestosProformasTableN);
  };*/

  const toggleVentas = () => {
    setShowVentas(!showVentas);
  };

  const toggleEncargos = () => {
    setShowEncargos(!showEncargos);
  };

  const togglePresupuestosProformas = () => {
    setShowPresupuestosProformas(!showPresupuestosProformas);
  };

  const onSelectPatient = (e) => {
    setFilterCodPaciente(e.codigo);
    setFilterIdPaciente(e.idPaciente);
  };

  const onChangePatient = (e) => {
    if (e === "") {
      setFilterCodPaciente("");
      setFilterIdPaciente(-1);
    }
  };

  const onChangeProduct = (e) => {
    setFilterCodProducto(e);
  };

  const onChangeNombre = (e) => {
    setFilterNombre(e);
  };

  const onChangeApellidos = (e) => {
    setFilterApellidos(e);
  };

  const onChangeTelefono = (e) => {
    setFilterTelefono(e);
  };

  const onChangeNOperacion = (e) => {
    setFilterNOperacion(e);
  };

  const onLinkPatient = () => {
    if (filterCodPaciente !== "") {
      window.open(`/patient-datos/${filterIdPaciente}`);
    }
  };

  const onChangeFilterFechaDesde = (e) => {
    setFilterFechaDesde(e.target.value);
  };

  const onChangeFilterFechaHasta = (e) => {
    setFilterFechaHasta(e.target.value);
  };

  const onChangeImporteDesde = (e) => {
    setFilterImporteDesde(e);
  };

  const onChangeImporteHasta = (e) => {
    setFilterImporteHasta(e);
  };

  const onChangeFilterFamiliaProducto = (e) => {
    setFilterFamiliaProducto(e);
  };

  const onChangeFilterEstadoPresupuesto = (e) => {
    const updatedFilterEstadoPresupuesto = filterEstadoPresupuesto.includes(
      e.id,
    )
      ? filterEstadoPresupuesto.filter((p) => p !== e.id)
      : [...filterEstadoPresupuesto, e.id];
    setFilterEstadoPresupuesto(updatedFilterEstadoPresupuesto);
  };

  const toggleShowControlSanitario = () => {
    setShowControlSanitario(!showControlSanitario);
  };

  const onChangeAlbaran = (e) => {
    setFilterAlbaran(e);
  };

  const onChangeExpedicion = (e) => {
    setFilterExpedicion(e);
  };

  const onChangeLote = (e) => {
    setFilterLote(e);
  };

  const onChangeFilterRealizadoPor = (e) => {
    setFilterRealizadoPor(e);
  };

  const onChangeFilterEntregadoPor = (e) => {
    setFilterEntregadoPor(e);
  };

  const toggleFilterVentasPendientesAbono = () => {
    setFilterVentasPendientesAbono(!filterVentasPendientesAbono);
  };

  const toggleFilterVentasPendientesEntrega = () => {
    setFilterVentasPendientesEntrega(!filterVentasPendientesEntrega);
  };

  const onChangeFilterVentasEstado = (e) => {
    const updatedFilterVentasEstado = filterVentasEstado.includes(e.id)
      ? filterVentasEstado.filter((p) => p !== e.id)
      : [...filterVentasEstado, e.id];
    setFilterVentasEstado(updatedFilterVentasEstado);
  };

  const onMoreVentas = () => {
    if (ventas.length < numLoadedVentas) {
      let ventasCounterN = ventasCounter + ventasLimit;
      setVentasCounter(ventasCounterN);
      loadVentas(true, ventasCounterN);
    }
  };

  const onMoreEncargos = () => {
    if (encargos.length < numLoadedEncargos) {
      let encargosCounterN = encargosCounter + encargosLimit;
      setEncargosCounter(encargosCounterN);
      loadEncargos(true, encargosCounterN);
    }
  };

  const onMorePresupuestosProformas = () => {
    if (presupuestosProformas.length < numLoadedPresupuestosProformas) {
      let presupuestosProformasCounterN =
        presupuestosCounter + presupuestosProformasLimit;
      setPresupuestosCounter(presupuestosProformasCounterN);
      loadPresupuestosProformas(true, presupuestosProformasCounterN);
    }
  };

  const handleSelectAllVentas = () => {
    setVentasTable((prev) => prev.map((item) => ({ ...item, selected: true })));
  };

  const handleCleanSelectedVentas = () => {
    setVentasTable((prev) =>
      prev.map((item) => ({ ...item, selected: false })),
    );
  };

  const exportVentas = async (format) => {
    const cabeceras = [
      { titulo: "Venta", tipo: "int", sumatorio: false },
      { titulo: "Estado", tipo: "string", sumatorio: false },
      { titulo: "Fecha", tipo: "string", sumatorio: false },
      { titulo: "Paciente", tipo: "int", sumatorio: false },
      { titulo: "Nombre", tipo: "string", sumatorio: false },
      { titulo: "Apellidos", tipo: "string", sumatorio: false },
      { titulo: "Teléfono", tipo: "string", sumatorio: false },
      { titulo: "Total", tipo: "currency", sumatorio: false },
      { titulo: "Abono", tipo: "currency", sumatorio: false },
      { titulo: "Pendiente", tipo: "currency", sumatorio: false },
      { titulo: "Entrega", tipo: "string", sumatorio: false },
    ];

    const filas = ventasTable
      .filter((venta) => venta.id !== "")
      .map((venta) => [
        venta.nOperation,
        venta.status.toUpperCase(),
        moment(venta.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm"),
        venta.patient,
        venta.name,
        venta.lastName,
        venta.phone,
        venta.total,
        venta.paid,
        venta.remaining === "-" ? formatCurrency(0) : venta.remaining,
        venta.deliver ? "X" : "",
      ]);

    const tablas = [
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras,
        filas,
      },
    ];

    await exportToFile(
      "Listado de ventas",
      [],
      false,
      false,
      format,
      tablas,
      -1,
      "",
    );
  };

  const handleSelectAllEncargos = () => {
    setEncargosTable((prev) =>
      prev.map((item) => ({ ...item, selected: true })),
    );
  };

  const handleCleanSelectedEncargos = () => {
    setEncargosTable((prev) =>
      prev.map((item) => ({ ...item, selected: false })),
    );
  };

  const exportEncargos = async (format) => {
    const cabeceras = [
      { titulo: "Encargo", tipo: "int", sumatorio: false },
      { titulo: "Fecha", tipo: "string", sumatorio: false },
      { titulo: "Paciente", tipo: "int", sumatorio: false },
      { titulo: "Nombre", tipo: "string", sumatorio: false },
      { titulo: "Apellidos", tipo: "string", sumatorio: false },
      { titulo: "Teléfono", tipo: "string", sumatorio: false },
      { titulo: "Total", tipo: "currency", sumatorio: false },
      { titulo: "> 15 días", tipo: "string", sumatorio: false },
    ];

    const filas = encargosTable.map((encargo) => {
      const daysSince = moment().diff(
        moment(encargo.date, "DD/MM/YYYY HH:mm"),
        "days",
      );

      return [
        encargo.nOperation,
        encargo.date,
        encargo.patient,
        encargo.name,
        encargo.lastName,
        encargo.phone,
        encargo.total,
        daysSince > 15 ? "X" : "",
      ];
    });

    const tablas = [
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras,
        filas,
      },
    ];

    await exportToFile(
      "Listado de encargos pendientes",
      [],
      false,
      false,
      format,
      tablas,
      -1,
      "",
    );
  };

  const deleteSelectedEncargos = async () => {
    const idsEncargo = encargosTable
      .filter((row) => row.selected && row.id !== "")
      .map((row) => row.id);

    await rpost("ventas/EliminarEncargo.php", {
      token: userData.token,
      idsEncargo,
      idAgente: userData.id,
    });

    removePopupQuestion();
    loadEncargos(false, 0);
  };

  const handleDeleteEncargos = () => {
    const haySeleccionados = encargosTable.some(
      (row) => row.selected && row.id !== "",
    );
    if (!haySeleccionados) {
      createPopupQuestion(
        "Debe seleccionar algún encargo para eliminar.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return;
    }
    createPopupQuestion(
      "¿Desea eliminar los encargos seleccionados?",
      deleteSelectedEncargos,
      removePopupQuestion,
      "Sí",
      "No",
    );
  };

  const handleSelectAllPresupuestosProformas = () => {
    setPresupuestosProformasTable((prev) =>
      prev.map((item) => ({ ...item, selected: true })),
    );
  };

  const handleCleanSelectedPresupuestosProformas = () => {
    setPresupuestosProformasTable((prev) =>
      prev.map((item) => ({ ...item, selected: false })),
    );
  };

  const exportPresupuestosProformas = async (format) => {
    const cabeceras = [
      { titulo: "Id", tipo: "int", sumatorio: false },
      { titulo: "Fecha", tipo: "string", sumatorio: false },
      { titulo: "Paciente", tipo: "int", sumatorio: false },
      { titulo: "Nombre", tipo: "string", sumatorio: false },
      { titulo: "Apellidos", tipo: "string", sumatorio: false },
      { titulo: "Teléfono", tipo: "string", sumatorio: false },
      { titulo: "Total", tipo: "currency", sumatorio: false },
      { titulo: "Válido hasta", tipo: "string", sumatorio: false },
      { titulo: "Estado", tipo: "string", sumatorio: false },
    ];

    const filas = presupuestosProformasTable.map((presupuesto) => {
      let estado = "";
      if (presupuesto.status === true) {
        estado = "ACEPTADO";
      } else if (presupuesto.status === false) {
        estado = "RECHAZADO";
      }

      return [
        presupuesto.nOperation,
        presupuesto.date,
        presupuesto.patient,
        presupuesto.name,
        presupuesto.lastName,
        presupuesto.phone,
        presupuesto.total,
        moment(presupuesto.expirationDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        estado,
      ];
    });

    const tablas = [
      {
        titulosTabla: [],
        numReferencias: "",
        extraCabeceras: [],
        cabeceras,
        filas,
      },
    ];

    await exportToFile(
      "Listado de presupuestos / proformas",
      [],
      false,
      false,
      format,
      tablas,
      -1,
      "",
    );
  };

  const resetVentasFilters = () => {
    setFilterVentasPendientesAbono(false);
    setFilterVentasPendientesEntrega(false);
    setFilterVentasEstado([]);
    handleCleanSelectedVentas();
  };

  const resetPresupuestosProformasFilters = () => {
    setFilterPresupuestos(true);
    setFilterProformas(true);
    setFilterEstadoPresupuesto([]);
    handleCleanSelectedPresupuestosProformas();
  };

  const togglePresupuestos = () => {
    setFilterPresupuestos(!filterPresupuestos);
  };

  const toggleProformas = () => {
    setFilterProformas(!filterProformas);
  };

  const resetFilters = () => {
    setFilterCodPaciente("");
    setFilterIdPaciente(-1);
    setFilterCodProducto("");
    setFilterNombre("");
    setFilterApellidos("");
    setFilterTelefono("");
    setFilterNOperacion("");
    setFilterFechaDesde("");
    setFilterFechaHasta("");
    setFilterImporteDesde("");
    setFilterImporteHasta("");
    setFilterFamiliaProducto(PRODUCT_FAMILIES[0]);
    setFilterRealizadoPor(agents[0]);
    setFilterEntregadoPor(agents[0]);
    setFilterAlbaran("");
    setFilterExpedicion("");
    setFilterLote("");
    setShowControlSanitario(false);
  };

  const onClickVenta = (params) => {
    onClickMenuOption("venta", params);
  };

  const onClickEncargo = (params) => {
    onClickMenuOption("encargo", params);
  };

  const onClickPresupuesto = (params) => {
    onClickMenuOption("presupuesto", params);
  };

  const onClickProforma = (params) => {
    onClickMenuOption("proforma", params);
  };

  const openCashPopup = (show) => {
    setShowCashPopup(show);
  };

  const openCashMovementPopup = (type) => {
    setCashMovementPopup(type);
  };

  const printSelectedVentas = async ({ printObservations, printPayments }) => {
    const idVenta = ventasTable
      .filter((row) => row.selected && row.id !== "")
      .map((row) => row.id);

    return await printInvoiceDirect({
      idVenta,
      invoiceType: undefined,
      printObservations,
      printPayments,
      createPopupQuestion,
      removePopupQuestion,
    });
  };

  const sendSelectedVentasEmail = async ({
    printObservations,
    printPayments,
  }) => {
    const idVenta = ventasTable
      .filter((row) => row.selected && row.id !== "")
      .map((row) => row.id);

    const response = await printInvoice({
      idVenta,
      invoiceType: undefined,
      printObservations,
      printPayments,
      createPopupQuestion,
      removePopupQuestion,
    });

    if (!response) return false;

    setVentasEmailAttachment({
      titulo: response.nombreFichero,
      fichero: response.fichero,
    });
    setShowVentasEmailPopup(true);
    return true;
  };

  const printSelectedPresupuestosProformas = async ({ printObservations }) => {
    const idPresupuesto = presupuestosProformasTable
      .filter((row) => row.selected && row.id !== "" && row.type === "PRE")
      .map((row) => row.id);
    const idProforma = presupuestosProformasTable
      .filter((row) => row.selected && row.id !== "" && row.type !== "PRE")
      .map((row) => row.id);

    const requestDocument = async (endpoint, params) =>
      await rpost(endpoint, {
        token: userData.token,
        idOptica: selectedOptic.id,
        ...params,
        imprimirObservaciones: printObservations,
      });

    const presupuestoResponse =
      idPresupuesto.length > 0
        ? await requestDocument("gestionDocumental/ImprimirPresupuesto.php", {
            idPresupuesto,
            maxDias: "",
          })
        : null;

    const proformaResponse =
      idProforma.length > 0
        ? await requestDocument("gestionDocumental/ImprimirProforma.php", {
            idProforma,
            maxDias: "",
          })
        : null;

    const presupuestoOk =
      idPresupuesto.length === 0 ||
      (presupuestoResponse &&
        !presupuestoResponse.error &&
        presupuestoResponse.fichero);
    const proformaOk =
      idProforma.length === 0 ||
      (proformaResponse && !proformaResponse.error && proformaResponse.fichero);

    if (idPresupuesto.length > 0 && presupuestoOk) {
      await openDataUriInNewTab(
        presupuestoResponse.fichero,
        presupuestoResponse.nombreFichero,
      );
    }
    if (idProforma.length > 0 && proformaOk) {
      await openDataUriInNewTab(
        proformaResponse.fichero,
        proformaResponse.nombreFichero,
      );
    }

    if (!presupuestoOk && !proformaOk) {
      createPopupQuestion(
        presupuestoResponse?.error ||
          proformaResponse?.error ||
          "Error al generar presupuesto/proforma.",
        removePopupQuestion,
        null,
        "Cerrar",
      );
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (show && !loaded) {
      setLoaded(true);
      loadAgents();
      loadEncargos(false, 0);
      loadPresupuestosProformas();
    }
  }, [show]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (show && loaded) {
        loadVentas(false, 0);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [
    filterCodPaciente,
    filterCodProducto,
    filterNombre,
    filterApellidos,
    filterTelefono,
    filterNOperacion,
    filterFechaDesde,
    filterFechaHasta,
    filterImporteDesde,
    filterImporteHasta,
    filterFamiliaProducto,
    filterRealizadoPor,
    filterEntregadoPor,
    filterAlbaran,
    filterExpedicion,
    filterLote,
    filterVentasPendientesAbono,
    filterVentasPendientesEntrega,
    filterVentasEstado,
    ventasLimit,
  ]);

  useEffect(() => {
    if (show && loaded) {
      if (debtor) {
        resetFilters();
        setFilterCodPaciente(debtor.code);
        setFilterIdPaciente(debtor.id);
        setFilterVentasPendientesAbono(true);
        setFilterVentasPendientesEntrega(false);
        setShowVentas(true);
        setShowEncargos(false);
        setShowPresupuestosProformas(false);
      } else if (orderer) {
        resetFilters();
        setFilterCodPaciente(orderer.code);
        setFilterIdPaciente(orderer.id);
        setShowVentas(false);
        setShowEncargos(true);
        setShowPresupuestosProformas(false);
      } else {
        loadVentas(false, 0);
        loadEncargos(false, 0);
      }
    }
  }, [show, loaded, debtor, orderer]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (show && loaded) {
        loadEncargos(false, 0);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [
    filterCodPaciente,
    filterCodProducto,
    filterNombre,
    filterApellidos,
    filterTelefono,
    filterNOperacion,
    filterFechaDesde,
    filterFechaHasta,
    filterImporteDesde,
    filterImporteHasta,
    filterFamiliaProducto,
    filterRealizadoPor,
    filterAlbaran,
    filterExpedicion,
    filterLote,
    encargosLimit,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (show && loaded) {
        loadPresupuestosProformas(false, 0);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [
    show,
    filterCodPaciente,
    filterCodProducto,
    filterNombre,
    filterApellidos,
    filterTelefono,
    filterNOperacion,
    filterFechaDesde,
    filterFechaHasta,
    filterImporteDesde,
    filterImporteHasta,
    filterFamiliaProducto,
    filterRealizadoPor,
    filterAlbaran,
    filterExpedicion,
    filterLote,
    filterPresupuestos,
    filterProformas,
    filterEstadoPresupuesto,
    presupuestosLimit,
  ]);

  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data sales-data">
      <div className="patient-data-header">
        <span className="header-text">TPV</span>
      </div>
      <div className="patient-data-content store-data-content">
        <div className="action-bar action-bar-store">
          <div className="action-bar-resume">
            <span>TPV</span>
            <span>|</span>
            <span className="signed-text">
              Listado de ventas, encargos y presupuestos
            </span>
          </div>
        </div>
        <div
          className="store-info sales-info-header"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div className="sales-content">
            <div className="patient-search-content store-search-content">
              <div className="general-header">
                <div className="general-header-info">
                  <div className="opt-table-title opt-table-title-options">
                    <span>Búsqueda de operaciones TPV</span>
                    <button className="cell-label" onClick={resetFilters}>
                      Limpiar filtros
                    </button>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title">
                    <div className="sales-filters-header-left">
                      <div
                        className="data-field c-pointer"
                        onClick={toggleVentas}
                      >
                        <span className="label">Ventas</span>
                        <CheckBox
                          tabIndex={1}
                          active={showVentas}
                          onClick={() => {}}
                        />
                      </div>
                      <div
                        className="data-field c-pointer"
                        onClick={toggleEncargos}
                      >
                        <span className="label">Encargos pendientes</span>
                        <CheckBox
                          tabIndex={2}
                          active={showEncargos}
                          onClick={() => {}}
                        />
                      </div>
                      <div
                        className="data-field c-pointer"
                        onClick={togglePresupuestosProformas}
                      >
                        <span className="label">Presupuestos / Proformas</span>
                        <CheckBox
                          tabIndex={3}
                          active={showPresupuestosProformas}
                          onClick={() => {}}
                        />
                      </div>
                    </div>
                    <div className="sales-filters-header-right">
                      <ButtonIconH
                        text="Detalle de caja"
                        onClick={() => openCashPopup(true)}
                      />
                      <ButtonIconH
                        text="Insertar"
                        onClick={() => openCashMovementPopup("insertion")}
                      />
                      <ButtonIconH
                        text="Extraer"
                        onClick={() => openCashMovementPopup("extraction")}
                      />
                      {/*<ButtonIconH text="Cierre de caja" onClick={() => {}} />*/}
                    </div>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-content">
                    <div className="screen-row-3">
                      <div className="screen-item">
                        <div className="screen-item-2">
                          <div className="cell-extra">
                            <span className="label">Cod. paciente</span>
                          </div>
                          <InputSearch
                            id="codigorec"
                            size={1}
                            tabIndex={4}
                            link={true}
                            code={true}
                            op={filterCodPaciente}
                            onSelect={onSelectPatient}
                            onClickLink={onLinkPatient}
                            showCode={true}
                            onChange={onChangePatient}
                          />
                        </div>
                        <div className="screen-item-2">
                          <div className="cell-extra">
                            <span className="label">Cod. producto</span>
                          </div>
                          <InputData
                            tabIndex={5}
                            type="type-only-charnumbers"
                            size={1}
                            input={filterCodProducto}
                            onChange={onChangeProduct}
                          />
                        </div>
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra">
                          <span className="label">Nombre</span>
                        </div>
                        <InputData
                          tabIndex={6}
                          type="type-alpha"
                          size={0}
                          input={filterNombre}
                          onChange={onChangeNombre}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra">
                          <span className="label">Apellidos</span>
                        </div>
                        <InputData
                          tabIndex={7}
                          type="type-alpha"
                          size={0}
                          input={filterApellidos}
                          onChange={onChangeApellidos}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="screen-item-2">
                          <div className="cell-extra">
                            <span className="label">Teléfono</span>
                          </div>
                          <InputData
                            tabIndex={8}
                            type="type-phone"
                            size={1}
                            input={filterTelefono}
                            onChange={onChangeTelefono}
                          />
                        </div>
                        <div className="screen-item-2">
                          <div className="cell-extra">
                            <span className="label">Nº operación</span>
                          </div>
                          <InputData
                            tabIndex={9}
                            type="type-alphanum"
                            size={1}
                            input={filterNOperacion}
                            onChange={onChangeNOperacion}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="screen-row-3">
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Fecha desde</span>
                        </div>
                        <input
                          type="date"
                          tabIndex={10}
                          className="input-field"
                          value={filterFechaDesde}
                          onChange={onChangeFilterFechaDesde}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              inputOnEnter(e);
                            }
                          }}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Fecha hasta</span>
                        </div>
                        <input
                          type="date"
                          tabIndex={11}
                          className="input-field"
                          value={filterFechaHasta}
                          onChange={onChangeFilterFechaHasta}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              inputOnEnter(e);
                            }
                          }}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Importe desde</span>
                        </div>
                        <InputData
                          tabIndex={12}
                          type="type-float"
                          size={1}
                          input={filterImporteDesde}
                          onChange={onChangeImporteDesde}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Importe hasta</span>
                        </div>
                        <InputData
                          tabIndex={13}
                          type="type-float"
                          size={1}
                          input={filterImporteHasta}
                          onChange={onChangeImporteHasta}
                        />
                      </div>
                    </div>
                    <div className="screen-row-3">
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Familia producto</span>
                        </div>
                        <Dropdown
                          id="sms-template"
                          tabIndex={14}
                          optionList={PRODUCT_FAMILIES}
                          size={1}
                          op={filterFamiliaProducto.id}
                          onChange={onChangeFilterFamiliaProducto}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Realizado por</span>
                        </div>
                        <Dropdown
                          id="sales-filter-realizado-por"
                          tabIndex={15}
                          optionList={agents}
                          size={1}
                          op={filterRealizadoPor.id}
                          onChange={onChangeFilterRealizadoPor}
                        />
                      </div>
                      <div className="screen-item">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Entregado por</span>
                        </div>
                        <Dropdown
                          id="sales-filter-entregado-por"
                          tabIndex={16}
                          optionList={agents}
                          size={1}
                          op={filterEntregadoPor.id}
                          onChange={onChangeFilterEntregadoPor}
                        />
                      </div>
                      <div className="screen-item fact">
                        <div
                          className="sale-fact-header"
                          onClick={toggleShowControlSanitario}
                        >
                          <span>Control sanitario</span>
                          <img
                            src={
                              showControlSanitario
                                ? "/images/arrow-up.svg"
                                : "/images/arrow-down.svg"
                            }
                          />
                        </div>
                      </div>
                      {showControlSanitario && (
                        <div className="screen-item">
                          <div className="cell-extra cell-extra-big-label">
                            <span className="label">Albarán</span>
                          </div>
                          <InputData
                            tabIndex={21}
                            type="type-alphanum"
                            size={1}
                            maxLength={50}
                            input={filterAlbaran}
                            onChange={onChangeAlbaran}
                          />
                        </div>
                      )}
                      {showControlSanitario && (
                        <div className="screen-item">
                          <div className="cell-extra cell-extra-big-label">
                            <span className="label">Expedición</span>
                          </div>
                          <InputData
                            tabIndex={22}
                            type="type-alphanum"
                            size={1}
                            maxLength={50}
                            input={filterExpedicion}
                            onChange={onChangeExpedicion}
                          />
                        </div>
                      )}
                      {showControlSanitario && (
                        <div className="screen-item">
                          <div className="cell-extra cell-extra-big-label">
                            <span className="label">Lote</span>
                          </div>
                          <InputData
                            tabIndex={23}
                            type="type-alphanum"
                            size={1}
                            maxLength={50}
                            input={filterLote}
                            onChange={onChangeLote}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="general-header-separator" />
                <div className="general-header-buttons">
                  <ButtonIconV
                    text="Nueva venta"
                    icon="/images/add-orange.svg"
                    onClick={() => onClickVenta({ saleId: -1 })}
                  />
                  <ButtonIconV
                    text="Nuevo encargo"
                    icon="/images/add-orange.svg"
                    onClick={() => onClickEncargo({ saleId: -1 })}
                  />
                  <ButtonIconV
                    text="Nuevo presupuesto"
                    icon="/images/add-orange.svg"
                    onClick={() => onClickPresupuesto({ saleId: -1 })}
                  />
                  <ButtonIconV
                    text="Nueva proforma"
                    icon="/images/add-orange.svg"
                    onClick={() => onClickProforma({ saleId: -1 })}
                  />
                </div>
              </div>
            </div>

            {/* VENTAS */}

            {showVentas && (
              <div className="patient-search-content store-search-content">
                <div className="opt-table-title opt-table-title-options">
                  <span>
                    Listado de ventas ({ventas.length} de{" "}
                    <span className="listado-total">{numLoadedVentas}</span>)
                  </span>
                  <button className="cell-label" onClick={resetVentasFilters}>
                    Limpiar filtros
                  </button>
                </div>
                <div className="screen-row screen-row-space-between screen-row-title">
                  <div className="sales-left">
                    <div
                      className="data-field c-pointer"
                      onClick={toggleFilterVentasPendientesAbono}
                    >
                      <span className="label">Pendientes de abono</span>
                      <CheckBox
                        tabIndex={17}
                        active={filterVentasPendientesAbono}
                        onClick={() => {}}
                      />
                    </div>
                    <div
                      className="data-field c-pointer"
                      onClick={toggleFilterVentasPendientesEntrega}
                    >
                      <span className="label">Pendientes de entrega</span>
                      <CheckBox
                        tabIndex={18}
                        active={filterVentasPendientesEntrega}
                        onClick={() => {}}
                      />
                    </div>
                  </div>
                  <div className="sales-right">
                    <DropdownFilter
                      icon={"/images/support-extra/resumen.svg"}
                      disabled={false}
                      optionList={[
                        {
                          id: "Venta",
                          text: "VENTA",
                          active: filterVentasEstado.includes("Venta"),
                        },
                        {
                          id: "Anulada",
                          text: "ANULADA",
                          active: filterVentasEstado.includes("Anulada"),
                        },
                        {
                          id: "Rectificativa",
                          text: "RECTIFICATIVA",
                          active: filterVentasEstado.includes("Rectificativa"),
                        },
                        {
                          id: "Rectificada",
                          text: "RECTIFICADA",
                          active: filterVentasEstado.includes("Rectificada"),
                        },
                      ]}
                      op={"ESTADO"}
                      selectedOptions={filterVentasEstado}
                      onChange={onChangeFilterVentasEstado}
                    />
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        /*{ id: "000", text: "2", active: ventasLimit === 2 },*/
                        { id: "00", text: "25", active: ventasLimit === 25 },
                        { id: "01", text: "50", active: ventasLimit === 50 },
                        { id: "02", text: "100", active: ventasLimit === 100 },
                      ]}
                      op={"MOSTRAR"}
                      selectedOptions={[]}
                      onChange={(e) => {
                        setVentasCounter(0);
                        setVentasLimit(parseInt(e.text));
                      }}
                    />
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        { id: "csv", text: "CSV" },
                        { id: "excel", text: "Excel" },
                        { id: "pdf", text: "PDF" },
                      ]}
                      op={"EXPORTAR COMO"}
                      selectedOptions={[]}
                      onChange={(e) => {
                        exportVentas(e.id);
                      }}
                    />
                    <ButtonIconH
                      text="Imprimir"
                      onClick={() => {
                        const haySeleccionadas = ventasTable.some(
                          (row) => row.selected && row.id !== "",
                        );
                        if (!haySeleccionadas) {
                          createPopupQuestion(
                            "Debe seleccionar alguna venta para imprimir sus facturas.",
                            removePopupQuestion,
                            null,
                            "Cerrar",
                          );
                          return;
                        }
                        setShowVentasInvoicePrintingPopup(true);
                      }}
                    />
                    <ButtonIconH
                      text="Email"
                      onClick={() => {
                        const haySeleccionadas = ventasTable.some(
                          (row) => row.selected && row.id !== "",
                        );
                        if (!haySeleccionadas) {
                          createPopupQuestion(
                            "Debe seleccionar alguna venta para enviar sus facturas.",
                            removePopupQuestion,
                            null,
                            "Cerrar",
                          );
                          return;
                        }
                        setShowVentasEmailPrintingPopup(true);
                      }}
                    />
                  </div>
                </div>
                <div className="screen-row screen-row-end screen-row-title tpv-seleccion">
                  <button
                    className="cell-label"
                    onClick={handleSelectAllVentas}
                    tabIndex={-1}
                  >
                    Seleccionar todos
                  </button>
                  |
                  <button
                    className="cell-label"
                    onClick={handleCleanSelectedVentas}
                    tabIndex={-1}
                  >
                    Limpiar selección
                  </button>
                </div>
                <div className="screen-item sales-table">
                  <DataTable
                    columns={ventasColumns}
                    data={ventasTable}
                    className="custom-datatable"
                    noDataComponent={""}
                    onRowClicked={(row, event) => {
                      if (row.id === "") {
                        return;
                      }
                      onClickMenuOption("venta", { saleId: row.id });
                    }}
                  />
                </div>
                <div className="sales-view-more">
                  <ButtonIconH
                    text="Ver más"
                    small={true}
                    onClick={onMoreVentas}
                  />
                </div>
              </div>
            )}

            {/* ENCARGOS */}

            {showEncargos && (
              <div className="patient-search-content store-search-content">
                <div className="opt-table-title">
                  <span>
                    Listado de encargos pendientes ({encargos.length} de{" "}
                    <span className="listado-total">{numLoadedEncargos}</span>)
                  </span>
                </div>
                <div className="screen-row screen-row-end screen-row-title">
                  <DropdownFilter
                    disabled={false}
                    optionList={[
                      { id: "00", text: "25", active: encargosLimit === 25 },
                      { id: "01", text: "50", active: encargosLimit === 50 },
                      { id: "02", text: "100", active: encargosLimit === 100 },
                    ]}
                    op={"MOSTRAR"}
                    selectedOptions={[]}
                    onChange={(e) => {
                      setEncargosLimit(parseInt(e.text));
                    }}
                  />
                  <DropdownFilter
                    disabled={false}
                    optionList={[
                      { id: "csv", text: "CSV" },
                      { id: "excel", text: "Excel" },
                      { id: "pdf", text: "PDF" },
                    ]}
                    op={"EXPORTAR COMO"}
                    selectedOptions={[]}
                    onChange={(e) => {
                      exportEncargos(e.id);
                    }}
                  />
                  <ButtonIconH
                    text="Imprimir"
                    onClick={() => {
                      const haySeleccionados = encargosTable.some(
                        (row) => row.selected && row.id !== "",
                      );
                      if (!haySeleccionados) {
                        createPopupQuestion(
                          "Debe seleccionar algún encargo para imprimir.",
                          removePopupQuestion,
                          null,
                          "Cerrar",
                        );
                        return;
                      }
                      setShowEncargosInvoicePrintingPopup(true);
                    }}
                  />
                  <ButtonIconH text="Eliminar" onClick={handleDeleteEncargos} />
                </div>
                <div className="screen-row screen-row-end screen-row-title tpv-seleccion">
                  <button
                    className="cell-label"
                    onClick={handleSelectAllEncargos}
                    tabIndex={-1}
                  >
                    Seleccionar todos
                  </button>
                  |
                  <button
                    className="cell-label"
                    onClick={handleCleanSelectedEncargos}
                    tabIndex={-1}
                  >
                    Limpiar selección
                  </button>
                </div>
                <div className="screen-item sales-table">
                  <DataTable
                    columns={encargosColumns}
                    data={encargosTable}
                    className="custom-datatable"
                    noDataComponent={""}
                    onRowClicked={(row, event) => {
                      onClickMenuOption("encargo", { saleId: row.id });
                    }}
                  />
                </div>
                <div className="sales-view-more">
                  <ButtonIconH
                    text="Ver más"
                    small={true}
                    onClick={onMoreEncargos}
                  />
                </div>
              </div>
            )}

            {/* PRESUPUESTOS/PROFORMAS */}

            {showPresupuestosProformas && (
              <div className="patient-search-content store-search-content presupuestos-search-content">
                <div className="opt-table-title opt-table-title-options">
                  <span>
                    Listado de presupuestos / proformas (
                    {presupuestosProformas.length} de{" "}
                    <span className="listado-total">
                      {numLoadedPresupuestosProformas}
                    </span>
                    )
                  </span>
                  <button
                    className="cell-label"
                    onClick={resetPresupuestosProformasFilters}
                  >
                    Limpiar filtros
                  </button>
                </div>
                <div className="screen-row screen-row-space-between screen-row-title">
                  <div className="sales-left">
                    <div
                      className="data-field c-pointer"
                      onClick={togglePresupuestos}
                    >
                      <span className="label">Presupuestos</span>
                      <CheckBox
                        tabIndex={19}
                        active={filterPresupuestos}
                        onClick={() => {}}
                      />
                    </div>
                    <div
                      className="data-field c-pointer"
                      onClick={toggleProformas}
                    >
                      <span className="label">Proformas</span>
                      <CheckBox
                        tabIndex={20}
                        active={filterProformas}
                        onClick={() => {}}
                      />
                    </div>
                  </div>
                  <div className="sales-right">
                    <DropdownFilter
                      icon={"/images/support-extra/resumen.svg"}
                      disabled={false}
                      optionList={ESTADO_PRESUPUESTO_OPTIONS.map((item) => ({
                        ...item,
                        active: filterEstadoPresupuesto.includes(item.id),
                      }))}
                      op={"ESTADO"}
                      selectedOptions={filterEstadoPresupuesto}
                      onChange={onChangeFilterEstadoPresupuesto}
                    />
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        {
                          id: "00",
                          text: "25",
                          active: presupuestosProformasLimit === 25,
                        },
                        {
                          id: "01",
                          text: "50",
                          active: presupuestosProformasLimit === 50,
                        },
                        {
                          id: "02",
                          text: "100",
                          active: presupuestosProformasLimit === 100,
                        },
                      ]}
                      op={"MOSTRAR"}
                      selectedOptions={[]}
                      onChange={(e) => {
                        setPresupuestosProformasLimit(parseInt(e.text));
                      }}
                    />
                    <DropdownFilter
                      disabled={false}
                      optionList={[
                        { id: "csv", text: "CSV" },
                        { id: "excel", text: "Excel" },
                        { id: "pdf", text: "PDF" },
                      ]}
                      op={"EXPORTAR COMO"}
                      selectedOptions={[]}
                      onChange={(e) => {
                        exportPresupuestosProformas(e.id);
                      }}
                    />
                    <ButtonIconH
                      text="Imprimir"
                      onClick={() => {
                        const haySeleccionados =
                          presupuestosProformasTable.some(
                            (row) => row.selected && row.id !== "",
                          );
                        if (!haySeleccionados) {
                          createPopupQuestion(
                            "Debe seleccionar algún presupuesto o proforma para imprimir.",
                            removePopupQuestion,
                            null,
                            "Cerrar",
                          );
                          return;
                        }
                        setShowPresupuestosProformasInvoicePrintingPopup(true);
                      }}
                    />
                  </div>
                </div>
                <div className="screen-row screen-row-end screen-row-title tpv-seleccion">
                  <button
                    className="cell-label"
                    onClick={handleSelectAllPresupuestosProformas}
                    tabIndex={-1}
                  >
                    Seleccionar todos
                  </button>
                  |
                  <button
                    className="cell-label"
                    onClick={handleCleanSelectedPresupuestosProformas}
                    tabIndex={-1}
                  >
                    Limpiar selección
                  </button>
                </div>
                <div className="screen-item sales-table">
                  <DataTable
                    columns={presupuestosProformasColumns}
                    data={presupuestosProformasTable}
                    className="custom-datatable"
                    noDataComponent={""}
                    onRowClicked={(row, event) => {
                      onClickMenuOption(
                        row.type === "PRE" ? "presupuesto" : "proforma",
                        { saleId: row.id },
                      );
                    }}
                  />
                </div>
                <div className="sales-view-more">
                  <ButtonIconH
                    text="Ver más"
                    small={true}
                    onClick={onMorePresupuestosProformas}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showCashPopup && (
        <CashPopup
          opticaId={selectedOptic.id}
          fechaInicio={moment().format("YYYY-MM-DD")}
          fechaFin={moment().format("YYYY-MM-DD")}
          tipo="movimientos"
          show={showCashPopup}
          onClose={() => openCashPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {cashMovementPopup && (
        <CashMovementPopup
          type={cashMovementPopup}
          show={!!cashMovementPopup}
          onClose={() => openCashMovementPopup(null)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {showVentasInvoicePrintingPopup && (
        <PopupInvoicePrinting
          show={showVentasInvoicePrintingPopup}
          title="Imprimir facturas"
          onPrint={printSelectedVentas}
          onClose={() => setShowVentasInvoicePrintingPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {showEncargosInvoicePrintingPopup && (
        <PopupInvoicePrintingSimple
          show={showEncargosInvoicePrintingPopup}
          title="Imprimir Encargos"
          endpoint="gestionDocumental/ImprimirEncargo.php"
          params={{
            idOrden: encargosTable
              .filter((row) => row.selected && row.id !== "")
              .map((row) => row.id),
            tipoEncargo: "completo",
          }}
          errorMessage="Error al generar encargos."
          onClose={() => setShowEncargosInvoicePrintingPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {showPresupuestosProformasInvoicePrintingPopup && (
        <PopupInvoicePrintingSimple
          show={showPresupuestosProformasInvoicePrintingPopup}
          title="Imprimir presupuestos / proformas"
          onPrint={printSelectedPresupuestosProformas}
          onClose={() =>
            setShowPresupuestosProformasInvoicePrintingPopup(false)
          }
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {showVentasEmailPrintingPopup && (
        <PopupInvoicePrinting
          show={showVentasEmailPrintingPopup}
          title="Enviar facturas por email"
          buttonText="Enviar email"
          onPrint={sendSelectedVentasEmail}
          onClose={() => setShowVentasEmailPrintingPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      {showVentasEmailPopup && (
        <PopupEmail
          show={showVentasEmailPopup}
          destinatario=""
          asunto="Facturas"
          adjuntos={ventasEmailAttachment ? [ventasEmailAttachment] : []}
          onCancel={() => setShowVentasEmailPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
    </div>
  );
};
